import getNodeEnv from './getNodeEnv';

export default function getEnvironment(): 'development' | 'production' | 'staging' {
  return process.env.IS_STAGING === 'true'
    ? 'staging'
    : getNodeEnv() === 'production'
      ? 'production'
      : 'development';
}
